<div
  data-cy="input-text-html"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [attr.data-cy-columnName]="data ? data.columnName : columnName"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss">
  @if (this.isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label"
      >{{ label }}</label
    >
  }
  <div #quillHeader [ngClass]="{ 'input-text-html-header-mandatory': isMandatory }">
    <!-- desktop -->
    <div class="input-text-html-header" [ngStyle]="{ display: isMobile ? 'none' : 'flex' }">
      <button [attr.aria-label]="'htmlEditor.bold' | translate" class="ql-bold" data-quill-action>Bold</button>
      <button [attr.aria-label]="'htmlEditor.italic' | translate" class="ql-italic" data-quill-action>Italic</button>
      <button [attr.aria-label]="'htmlEditor.underline' | translate" class="ql-underline" data-quill-action>Underline</button>
      <select class="ql-color" data-quill-action></select>
      <select class="ql-background" data-quill-action></select>
      <select class="ql-header" data-quill-action>
        <option data-quill-action value="1">Heading</option>
        <option data-quill-action value="2">Subheading</option>
        <option data-quill-action selected>Normal</option>
      </select>
      <select class="ql-font" data-quill-action>
        <option data-quill-action selected>Sans Serif</option>
        <option data-quill-action value="serif">Serif</option>
        <option data-quill-action value="monospace">Monospace</option>
        <option value="calibri">Calibri</option>
        <option value="arial">Arial</option>
        <option value="times-new-roman">Times new roman</option>
      </select>
      <button [attr.aria-label]="'htmlEditor.image' | translate" class="ql-image" data-quill-action>Image</button>
      <button [attr.aria-label]="'htmlEditor.link' | translate" class="ql-link" data-quill-action>link</button>
    </div>
    <!-- mobile -->
    <div class="input-text-html-header-mobile" [ngStyle]="{ display: isMobile ? 'flex' : 'none' }">
      <div class="input-text-html-header-mobile-display" (click)="displayMobileMenu = !displayMobileMenu">
        {{ 'htmlEditor.menu' | translate }}<span
          style="margin-left: 5px"
          [ngClass]="['fa', displayMobileMenu ? 'fa-chevron-down' : 'fa-chevron-right']"></span>
      </div>
      <div class="input-text-html-header-mobile-menu" [ngStyle]="{ display: displayMobileMenu ? 'flex' : 'none' }">
        <div class="input-text-html-header-mobile-menu-fieldset">
          <button [attr.aria-label]="'htmlEditor.bold' | translate" class="ql-bold"></button>
          <button [attr.aria-label]="'htmlEditor.italic' | translate" class="ql-italic"></button>
          <button [attr.aria-label]="'htmlEditor.underline' | translate" class="ql-underline"></button>
          <select class="ql-color"></select>
          <select class="ql-background"></select>
        </div>
        <div class="input-text-html-header-mobile-menu-fieldset">
          <select class="ql-header">
            <option value="1">Heading</option>
            <option value="2">Subheading</option>
            <option selected>Normal</option>
          </select>
          <select class="ql-font">
            <option selected>Sans Serif</option>
            <option value="serif">Serif</option>
            <option value="monospace">Monospace</option>
            <option value="calibri">Calibri</option>
            <option value="arial">Arial</option>
            <option value="times-new-roman">Times new roman</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div
    #quillEditor
    class="input-text-html-body"
    data-cy="input-text-html-body"
    [ngClass]="{ 'input-text-html-body-mandatory': isMandatory }"></div>
</div>
